import React, { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import "./Navbar.css";
import logo from "../assets/logo.0f5f5d96bef1bcf52038_compressed.webp";
import { FaBars, FaTimes } from "react-icons/fa";

const Navbar = ({ onNavClick }) => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [activePage, setActivePage] = useState("home");

  // Map URL → active key
  const getActivePageFromURL = useCallback(() => {
    const path = location.pathname;

    if (path.includes("vves")) return "vves";
    if (path.includes("inside")) return "inside";
    if (path.includes("learning")) return "learning";
    if (path.includes("innovation")) return "innovation";
    if (path.includes("sports")) return "sports";
    if (path.includes("admissions")) return "admissions";
    if (path.includes("life")) return "life";
    if (path.includes("parent")) return "parents";
    if (path.includes("spotlight")) return "spotlight";
    if (path.includes("support")) return "support";
    if (path.includes("mandatory-disclosure")) return "disclosure";

    return "home";
  }, [location.pathname]);

  useEffect(() => {
    setActivePage(getActivePageFromURL());
  }, [getActivePageFromURL]);

  const handleNavClick = (page) => {
    setActivePage(page);
    onNavClick(page);
    setMenuOpen(false);
  };

  return (
    <header className="nv-wrapper">
      {/* TOP STRIP */}
      <div className="nv-top">
        <div className="nv-top-inner">
          <div
            className="nv-brand"
            onClick={() => handleNavClick("home")}
            style={{ cursor: "pointer" }}
          >
            <img src={logo} alt="VVCMS Logo" className="nv-logo" />
          </div>

          <div className="nv-title-block">
            <div className="nv-society">
              VIVEK VARDHINI EDUCATION SOCIETY’S
            </div>
            <div className="nv-school">
              VIVEK VARDHINI CREATIVE MINDS SCHOOL
            </div>
            <div className="nv-tagline">
  <span>WHERE CURIOSITY MEETS CHARACTER</span>
  <span className="nv-cbse">CBSE CURRICULUM</span>
</div>

          </div>

          <button
            className="nv-hamburger"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>

      {/* BOTTOM NAV */}
      <div className={`nv-bottom ${menuOpen ? "open" : ""}`}>
        <nav className="nv-menu">
          <button
            className={activePage === "home" ? "active" : ""}
            onClick={() => handleNavClick("home")}
          >
            HOME
          </button>

          <button
            className={activePage === "vves" ? "active" : ""}
            onClick={() => handleNavClick("vves")}
          >
            VVES
          </button>

          <button
            className={activePage === "inside" ? "active" : ""}
            onClick={() => handleNavClick("inside")}
          >
            VVCMS AT A GLANCE
          </button>

          <button
            className={activePage === "learning" ? "active" : ""}
            onClick={() => handleNavClick("learning")}
          >
            THE LEARNING EDGE
          </button>

          <button
            className={activePage === "innovation" ? "active" : ""}
            onClick={() => handleNavClick("innovation")}
          >
            INNOVATION & INFRASTRUCTURE
          </button>

          <button
            className={activePage === "sports" ? "active" : ""}
            onClick={() => handleNavClick("sports")}
          >
            SPORTS ARENA
          </button>

          <button
            className={activePage === "admissions" ? "active" : ""}
            onClick={() => handleNavClick("admissions")}
          >
            ADMISSIONS
          </button>

          <button
            className={activePage === "life" ? "active" : ""}
            onClick={() => handleNavClick("life")}
          >
            LEARNING BEYOND THE CLASSROOM
          </button>

          <button
            className={activePage === "parents" ? "active" : ""}
            onClick={() => handleNavClick("parents")}
          >
            OUR CONNECT WITH PARENTS
          </button>

          <button
            className={activePage === "spotlight" ? "active" : ""}
            onClick={() => handleNavClick("spotlight")}
          >
            SPOTLIGHT & MEDIA
          </button>

          <button
            className={activePage === "support" ? "active" : ""}
            onClick={() => handleNavClick("support")}
          >
            SUPPORT & ENQUIRY DESK
          </button>

          <button
            className={activePage === "disclosure" ? "active" : ""}
            onClick={() => handleNavClick("disclosure")}
          >
            MANDATORY PUBLIC DISCLOSURE
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
